import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class UserFeedbackLinks extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			now: new Date().getTime()
		}
	}

	componentDidMount() {
	}

	render() {
		const {username, feedbackScore = 0, aboutMe = false} = this.props;

		return (
			<React.Fragment>
				<strong>{username}</strong> <a href={ "/feedback.asp?u=" + username}>({feedbackScore})</a> <a href="/help.asp?helpID=54">{this.renderFeedbackIcon(feedbackScore)}</a> {(aboutMe)&&<a href={"/aboutMe.asp?u=" + username} ><img className="l-vertical-align-middle" src="/images/bricks/me.png"/></a>}
			</React.Fragment>
		);
	}

	renderFeedbackIcon(fdbScore) {
		return <img className="l-vertical-align-middle" style={{width:"13px"}} src={blapp.url2.getFeedbackIconUrl(fdbScore)}/>;
	}

};